<template>
    <div class="invoice">
      <div class="check_zone">
        <input v-model="invoiceCode" id="personal" type="radio"  name="check" value="Person">
        <label for="personal" style="margin-left: 27px">个人</label>
        <input v-model="invoiceCode" id="company" type="radio"  name="check" value="Company">
        <label for="company" style="margin-left: 16px">公司</label>
      </div>
      <div v-show="invoiceCode=='Person'" class="person">
        <p>请查对确认发票抬头，发票一经开具，抬头无法更改。</p>
        <div class="f_item">
          <p class="input_t">发票抬头:</p>
          <div class="input_z">
            <input type="text" name="bill" v-model="invoiceTitle1" placeholder="请输入发票抬头">
          </div>
        </div>
        <p>发票地址同收货信息中的详细地址，请详细核对您的收货信息中的详细地址。</p>
      </div>
      <div v-show="invoiceCode=='Company'" class="company">
        <p>请查对确认发票抬头，发票一经开具，抬头无法更改。</p>
        <div class="f_item">
          <p class="input_t">发票抬头:</p>
          <div class="input_z">
            <input type="text" name="bill" v-model="invoiceTitle2" placeholder="请输入公司抬头">
          </div>
        </div>
        <div class="f_item">
          <p class="input_t">公司税号:</p>
          <div class="input_z">
            <input type="text" v-model="companyTaxCode" class="invoiceCode" name="bill" placeholder="请输入公司税号"></div>
        </div>
        <p>发票地址同收货信息中的详细地址，请详细核对您的收货信息中的详细地址。</p>
      </div>
      <div @click="ensure" class="ensure">确认</div>
    </div>
</template>
<style scoped lang="less">
  .invoice {
    padding: 18px;
  }
  .check_zone {
    margin-bottom: 30px;
    input[type='radio'] {
      display: none;
    }
    label {
      position: relative;
      margin-right: 25px;
    }
    label:before {
      content: '';
      display: inline-block;
      width: 14px;
      height: 14px;
      position: absolute;
      left: -18px;
      top: 5px;
      background: url("../assets/image/order/d_check.png") no-repeat;
      background-size: 100%;
    }
    input[type=radio]:checked + label:before {
      background:url("../assets/image/order/d_checked.png") no-repeat;
      background-size:100% auto;
    }
  }
  .person,.company {
    p {
      font-size: 12px;
      color: #949494;;
    }
    .f_item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 12px 0;
      .input_t {
        color: #000000;
      }
      .input_z {
        width: 78%;
        height: 42px;
        border: 1px solid #e0e0e0;
        color: #b2b2b2;
        font-size: 14px;
        padding-left: 8px;
        input {
          width:90%;
          height:100%;
          color:#b2b2b2;
        }
      }
    }
  }
  .ensure {
    margin-top: 30px;
    width: 100%;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #2cb9e7;
    color: #ffffff;
    font-size: 16px;
  }
</style>
<script>

    export default{
        data(){
            return{
                companyTaxCode: this.$store.state.companyTaxCode,
                invoiceCode: this.$store.state.invoiceCode,
                invoiceTitle1: this.$store.state.invoiceTitle1,
                invoiceTitle2: this.$store.state.invoiceTitle2,
            }
        },
        components:{

        },
        methods: {
          ensure() {
            this.$store.commit('setState',{
              companyTaxCode: this.companyTaxCode,
              invoiceCode: this.invoiceCode,
              invoiceTitle1: this.invoiceTitle1,
              invoiceTitle2: this.invoiceTitle2
            })
            console.log(`invoiceCode:${this.invoiceCode}`)
            console.log(`invoiceTitle1:${this.invoiceTitle1}`)
            this.$router.push({path:'/SubmitOrder'});
          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/InvoiceEdit.vue